<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo" />
        <div class="box">
          <div class="title is-4">Envianos tu consulta</div>
          <hr />
          <div class="columns is-multiline">
            <div class="column is-5">
              <b-field
                label="Nombre"
                :type="{'is-danger': errors.has('nombre')}"
                :message="errors.first('nombre')"
              >
                <b-input
                  placeholder="Ingrese su nombre"
                  v-model="nombre"
                  autofocus
                  name="nombre"
                  v-validate="{ required: true }"
                  v-on:key.enter="enviarCorreo()"
                ></b-input>
              </b-field>
              <b-field
                label="Apellido"
                :type="{'is-danger': errors.has('apellido')}"
                :message="errors.first('apellido')"
              >
                <b-input
                  placeholder="Ingrese su apellido"
                  v-model="apellido"
                  name="apellido"
                  v-validate="{ required: true }"
                  v-on:key.enter="enviarCorreo()"
                ></b-input>
              </b-field>
              <b-field
                label="Correo electrónico"
                :type="{'is-danger': errors.has('email')}"
                :message="errors.first('email')"
              >
                <b-input
                  type="email"
                  placeholder="Ingrese su correo"
                  v-model="mail"
                  name="email"
                  v-validate="{ required: true, email: true }"
                  v-on:key.enter="enviarCorreo()"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-7">
              <b-field
                label="Mensaje"
                :type="{'is-danger': errors.has('mensaje')}"
                :message="errors.first('mensaje')"
              >
                <b-input
                  type="textarea"
                  placeholder="Ingrese su mensaje"
                  v-model="mensaje"
                  name="mensaje"
                  v-validate="{ required: true }"
                  v-on:key.enter="enviarCorreo()"
                >
                </b-input>
              </b-field>
              <p class="control">
                <button v-on:click="enviarCorreo()" class="button is-primary">Enviar</button>
              </p>
            </div>
            <div class="column is-12">
              <b-notification
                type="is-primary"
                has-icon
                aria-close-label="Close notification">
                Si por alguna razón al hacer clic en enviar tienes algún problema, por favor escribinos un mail a <strong><a :href="`mailto:${mailTo}`">{{mailTo}}</a></strong>
              </b-notification>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="title is-4">Teléfonos</div>
          <hr />
          <div class="columns">
            <div class="column">
              <a href="https://api.whatsapp.com/send?phone=543434532596&text=Por%20favor%20requiero%20más%20información%20WEB%20Gracias" class="whatsapp-flotado"><i class="mdi mdi-whatsapp"></i></a>
            </div>
            <div class="column">
              <div class="title is-6">Casa Central - Uruguay 32</div>
              <div class="title is-7">Tel: (0343) 4221532/4225036</div>
            </div>
            <div class="column">
              <div class="title is-6">Sucursal - San Martín 865</div>
              <div class="title is-7">Tel: (0343) 4219795</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Redes />
    <Promo />
  </div>
</template>

<style lang="css" scoped>
.whatsapp-flotado {
  background: #25d366;
  color: #fff;
  border-radius: 50%;
  font-size: 30px;
  display: block;
  height: 45px;
  right: 20px;
  padding: 0px;
  text-align: center;
  width: 45px;
  box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.32);
}
.whatsapp-flotado:hover {
  background: #fff;
  color: #25d366;
}
</style>

<script>
import Promo from '@/components/Promo.vue'
import TituloPrincipal from '@/components/TituloPrincipal.vue'
import Redes from '@/components/Redes.vue'

export default {
  name: 'Contacto',
  data () {
    return {
      titulo: 'Contacto',
      subtitulo: 'Comentanos tus inquietudes',
      mail: '',
      nombre: '',
      apellido: '',
      mensaje: '',
      mailTo: process.env.VUE_APP_MAIL_CONTACTO
    }
  },
  methods: {
    enviarCorreo () {
      const componenteVue = this
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$buefy.toast.open({
            message: 'Revise los datos',
            type: 'is-danger',
            position: 'is-top'
          })
        } else {
          window.location.href = `mailto:${componenteVue.mailTo}?subject=Contacto Web&body=Hola, soy ${componenteVue.nombre} ${componenteVue.apellido} y tengo la siguiente consulta: ${componenteVue.mensaje}. Por favor contestarme a ${componenteVue.mail}`
        }
      })
    }
  },
  components: {
    TituloPrincipal,
    Promo,
    Redes
  }
}
</script>
